import * as Yup from 'yup';

const schema = Yup.object().shape({
  firstName: Yup.string().required('First name is required'),
  lastName: Yup.string().required('Surname is required'),
  email: Yup.string()
    .email('Invalid email address')
    .required('Email is required'),
  phone: Yup.string().required('Phone number is required'),
  message: Yup.string().required('Message is required'),
});

export default schema;



// WEBPACK FOOTER //
// ./app/javascript/pro_platform/components/EnquireModal/parts/EnquireForm/schema.js